import Platform from "./platform"
import wx from 'weixin-js-sdk'
import http from "@/utils/http";
import { env } from "../utils/commons"
import { sysParams } from "@/utils/sys-variable";

class PlatformWechat extends Platform {
    constructor(params) {
        super(params);
        this.configured = false
    }

    config() {
        return new Promise((resolve, reject) => {
            if (this.configured) {
                resolve()
            } else {
                http.get('/weixin/jssdkapi.htm', { url: window.location.href.split('#')[0] })
                    .then(resp => {
                        console.log('---------------', resp);
                        wx.ready(() => {
                            this.configured = true
                            resolve()
                        })
                        wx.error(error => {
                            console.error('微信jssdk权限验证失败', error)
                            reject(error)
                        })
                        wx.config({
                            debug: false,
                            appId: resp.appId,
                            timestamp: resp.timestamp,
                            nonceStr: resp.nonceStr,
                            signature: resp.signature,
                            jsApiList: ['getLocation', 'hideOptionMenu', 'closeWindow', 'openEnterpriseChat',
                                'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'translateVoice', "checkJsApi", "openLocation"]
                        })
                    })
            }
        })
    }

    urlChange(to) {
        super.urlChange(to)

        /*小程序环境*/
        if (env.miniProgram) {
            /*1判断是否显示主页按钮*/
            //sysParams('miniProgramHomeUrl').then(resp => renderHomeBtn(resp))

            /*2向小程序发送当前url*/
            let num = 0
            let timer = window.setInterval(() => {
                if (++num > 10) clearInterval(timer)
                try {
                    wx.miniProgram.postMessage({ data: { url: encodeURI(window.location.href), title: document.title } })
                } catch (err) {
                }
            }, 1000)
        }
    }

    close() {
    }

    hideOptionMenu() {
        this.config().then(() => wx.hideOptionMenu())
    }

    openChat(userIds, groupName = '') {
        this.config().then(() => wx.openEnterpriseChat({
            userIds: userIds,
            groupName: groupName,
            fail: function (err) {
                console.error(`创建会话失败, userIds: ${userIds}`, err)
            }
        }))
    }
}

export default PlatformWechat